/**
 * Japanese (JPY) mock transactions. Transfer pairs carry the same `paired*`
 * fields the app's groupTransferPairs() produces, so the real DoubleRow
 * component renders the two-sided sublines.
 */

/** @type {Array<import('../../mock-transactions.js').MockTransaction>} */
export const MOCK_TRANSACTIONS_JA = [
	{
		id: 'txn-1',
		date: '2026-08-03',
		type: 'Deposit',
		amount: 350000,
		description: '給与',
		accountId: 'acc-checking',
		accountName: 'みどり銀行',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: '収入',
	},
	{
		id: 'txn-2',
		isTransferPair: true,
		date: '2026-08-01',
		type: 'Transfer',
		amount: 50000,
		description: '貯金へ',
		accountId: 'acc-checking',
		accountName: 'みどり銀行',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: '貯金',
		pairedType: 'Transfer',
		pairedAmount: 50000,
		pairedCurrencySymbol: '\u00A5',
		pairedCurrencyDecimalPlaces: 0,
		pairedAccountName: '定期預金',
		pairedAccountId: 'acc-savings',
		pairedDate: '2026-08-01',
	},
	{
		id: 'txn-3',
		isTransferPair: true,
		date: '2026-08-01',
		type: 'Regular Investment',
		amount: 100000,
		description: '積立投資',
		accountId: 'acc-checking',
		accountName: 'みどり銀行',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: '投資',
		pairedType: 'Regular Investment',
		pairedAmount: 100000,
		pairedCurrencySymbol: '\u00A5',
		pairedCurrencyDecimalPlaces: 0,
		pairedAccountName: 'NISA',
		pairedAccountId: 'acc-broker',
		pairedDate: '2026-08-01',
	},
	{
		id: 'txn-4',
		isTransferPair: true,
		date: '2026-07-20',
		type: 'Credit Card Payment',
		amount: 125000,
		description: 'クレジットカード支払い',
		accountId: 'acc-checking',
		accountName: 'みどり銀行',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: '支払い',
		pairedType: 'Credit Card Payment',
		pairedAmount: 125000,
		pairedCurrencySymbol: '\u00A5',
		pairedCurrencyDecimalPlaces: 0,
		pairedAccountName: 'クレジットカード',
		pairedAccountId: 'acc-credit',
		pairedDate: '2026-07-20',
	},
	{
		id: 'txn-5',
		date: '2026-07-24',
		type: 'Withdrawal',
		amount: 20000,
		description: 'コンビニ',
		accountId: 'acc-checking',
		accountName: 'みどり銀行',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: '現金',
	},
	{
		id: 'txn-6',
		date: '2026-07-22',
		type: 'Purchase',
		amount: 4830,
		description: 'スーパー',
		accountId: 'acc-credit',
		accountName: 'クレジットカード',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: '食費',
	},
	{
		id: 'txn-7',
		date: '2026-07-18',
		type: 'Reward Earned',
		amount: 4200,
		description: 'マイル獲得',
		accountId: 'acc-flight',
		accountName: 'フライトマイル',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: 'マイル',
	},
];

/** @type {Array<import('../../mock-transactions.js').MockTransaction>} */
export const MOCK_AVIOS_TRANSACTIONS_JA = [
	{
		id: 'av-1',
		date: '2026-08-02',
		type: 'Reward Earned',
		amount: 5600,
		description: 'ホテル宿泊ボーナス',
		accountId: 'acc-flight',
		accountName: 'フライトマイル',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: 'マイル',
	},
	{
		id: 'av-2',
		date: '2026-07-28',
		type: 'Reward Redemption',
		amount: 20000,
		description: '特典航空券（エコノミー）',
		accountId: 'acc-flight',
		accountName: 'フライトマイル',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: '旅行',
	},
	{
		id: 'av-3',
		date: '2026-07-18',
		type: 'Reward Earned',
		amount: 4200,
		description: 'フライトボーナス',
		accountId: 'acc-flight',
		accountName: 'フライトマイル',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: 'マイル',
	},
];
